function FinmoLogo({ width = "130px", color = "#382c4f", iconOnly = false }) {
  if (iconOnly) {
    return (
      <svg
        width={width}
        viewBox="0 0 48 48"
        style={{ color, display: "block" }}
        aria-label="Finmo"
      >
        <path
          d="M40.083 0C44.4554 0 48 3.54464 48 7.91699V40.083C48 44.4554 44.4554 48 40.083 48H7.91699C3.54464 48 0 44.4554 0 40.083V7.91699C0 3.54464 3.54464 0 7.91699 0H40.083ZM24.1357 30.5293C18.9109 33.6724 11.793 32.9131 11.793 32.9131V40.0449C11.793 40.0449 18.908 40.8042 24.1357 37.6611V30.5293ZM36.7529 17.5C36.7345 17.4983 30.8252 16.9638 24.04 20.9844C18.8556 24.0562 11.793 23.3145 11.793 23.3145V30.4453C11.793 30.4453 18.8527 31.1872 24.04 28.1152C30.8358 24.0883 36.7529 24.6318 36.7529 24.6318V17.5ZM36.7529 7.78516C36.7513 7.785 30.8349 7.23084 24.04 11.3438C18.8629 14.4744 11.8128 13.7238 11.793 13.7217V20.8447C11.793 20.8447 18.8527 21.6027 24.04 18.4648C30.8218 14.3599 36.7285 14.903 36.7529 14.9053V7.78516Z"
          fill="currentColor"
        />
      </svg>
    );
  }

  return (
    <svg
      width={width}
      viewBox="0 0 168 48"
      style={{ color, display: "block" }}
      aria-label="Finmo"
    >
      <g>
        <path
          d="M40.083 0C44.4554 0 48 3.54464 48 7.91699V40.083C48 44.4554 44.4554 48 40.083 48H7.91699C3.54464 48 0 44.4554 0 40.083V7.91699C0 3.54464 3.54464 0 7.91699 0H40.083ZM24.1357 30.5293C18.9109 33.6724 11.793 32.9131 11.793 32.9131V40.0449C11.793 40.0449 18.908 40.8042 24.1357 37.6611V30.5293ZM36.7529 17.5C36.7345 17.4983 30.8252 16.9638 24.04 20.9844C18.8556 24.0562 11.793 23.3145 11.793 23.3145V30.4453C11.793 30.4453 18.8527 31.1872 24.04 28.1152C30.8358 24.0883 36.7529 24.6318 36.7529 24.6318V17.5ZM36.7529 7.78516C36.7513 7.785 30.8349 7.23084 24.04 11.3438C18.8629 14.4744 11.8128 13.7238 11.793 13.7217V20.8447C11.793 20.8447 18.8527 21.6027 24.04 18.4648C30.8218 14.3599 36.7285 14.903 36.7529 14.9053V7.78516Z"
          fill="currentColor"
        />
        <path
          d="M155.402 38.0723C148.622 38.0723 143.699 33.5813 143.699 26.7583C143.699 19.9785 148.622 15.4443 155.402 15.4443C162.182 15.4443 167.104 19.9785 167.104 26.7583C167.104 33.5813 162.182 38.0723 155.402 38.0723ZM151.256 26.7583C151.256 30.6016 152.638 32.4585 155.402 32.4585C158.166 32.4585 159.547 30.6016 159.547 26.7583C159.547 22.9582 158.166 21.0581 155.402 21.0581C152.638 21.0581 151.256 22.9582 151.256 26.7583Z"
          fill="currentColor"
        />
        <path
          d="M108.924 37.7701V15.7466H116.265V19.8922C117.604 17.4308 119.806 15.4443 123.131 15.4443C126.974 15.4443 128.615 17.5171 129.177 20.3672C130.472 17.6899 132.761 15.4443 136.259 15.4443C141.225 15.4443 142.52 18.899 142.52 23.0446V37.7701H135.179V25.2038C135.179 22.0082 134.402 20.7127 132.718 20.7127C131.034 20.7127 129.393 22.8719 129.393 26.0674V37.7701H122.052V25.2038C122.052 22.0082 121.274 20.7127 119.59 20.7127C117.906 20.7127 116.265 22.8719 116.265 26.0674V37.7701H108.924Z"
          fill="currentColor"
        />
        <path
          d="M85.2128 37.7701V15.7466H92.5539V20.5399C94.0654 17.7762 96.6995 15.4443 100.284 15.4443C105.25 15.4443 106.545 18.8989 106.545 23.9082V37.7701H99.2042V25.2037C99.2042 22.0081 98.4269 20.7126 96.3109 20.7126C94.1949 20.7126 92.5539 22.8718 92.5539 26.0674V37.7701H85.2128Z"
          fill="currentColor"
        />
        <path
          d="M61.3603 15.0123C61.3603 9.83026 64.4263 7.23926 69.7379 7.23926H73.1493V13.2849H70.6015C69.3492 13.2849 68.7015 13.8463 68.7015 15.0123V15.7464H73.1925V21.5761H68.7015V37.7699H61.3603V21.5761H58.4238V15.7464H61.3603V15.0123ZM75.0926 13.1986V7.49836H82.6065V13.1986H75.0926ZM75.179 37.7699V15.7464H82.5201V37.7699H75.179Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
}

export default FinmoLogo;
